import {cva} from 'class-variance-authority'

export type SpacingScale = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 8 | 10 | 12 | 16 | 20 | 24

const P_MAP: Record<SpacingScale, string> = {
  0: 'p-0',
  1: 'p-1',
  2: 'p-2',
  3: 'p-3',
  4: 'p-4',
  5: 'p-5',
  6: 'p-6',
  8: 'p-8',
  10: 'p-10',
  12: 'p-12',
  16: 'p-16',
  20: 'p-20',
  24: 'p-24',
}
const PX_MAP: Record<SpacingScale, string> = {
  0: 'px-0',
  1: 'px-1',
  2: 'px-2',
  3: 'px-3',
  4: 'px-4',
  5: 'px-5',
  6: 'px-6',
  8: 'px-8',
  10: 'px-10',
  12: 'px-12',
  16: 'px-16',
  20: 'px-20',
  24: 'px-24',
}
const PY_MAP: Record<SpacingScale, string> = {
  0: 'py-0',
  1: 'py-1',
  2: 'py-2',
  3: 'py-3',
  4: 'py-4',
  5: 'py-5',
  6: 'py-6',
  8: 'py-8',
  10: 'py-10',
  12: 'py-12',
  16: 'py-16',
  20: 'py-20',
  24: 'py-24',
}
const PT_MAP: Record<SpacingScale, string> = {
  0: 'pt-0',
  1: 'pt-1',
  2: 'pt-2',
  3: 'pt-3',
  4: 'pt-4',
  5: 'pt-5',
  6: 'pt-6',
  8: 'pt-8',
  10: 'pt-10',
  12: 'pt-12',
  16: 'pt-16',
  20: 'pt-20',
  24: 'pt-24',
}
const PR_MAP: Record<SpacingScale, string> = {
  0: 'pr-0',
  1: 'pr-1',
  2: 'pr-2',
  3: 'pr-3',
  4: 'pr-4',
  5: 'pr-5',
  6: 'pr-6',
  8: 'pr-8',
  10: 'pr-10',
  12: 'pr-12',
  16: 'pr-16',
  20: 'pr-20',
  24: 'pr-24',
}
const PB_MAP: Record<SpacingScale, string> = {
  0: 'pb-0',
  1: 'pb-1',
  2: 'pb-2',
  3: 'pb-3',
  4: 'pb-4',
  5: 'pb-5',
  6: 'pb-6',
  8: 'pb-8',
  10: 'pb-10',
  12: 'pb-12',
  16: 'pb-16',
  20: 'pb-20',
  24: 'pb-24',
}
const PL_MAP: Record<SpacingScale, string> = {
  0: 'pl-0',
  1: 'pl-1',
  2: 'pl-2',
  3: 'pl-3',
  4: 'pl-4',
  5: 'pl-5',
  6: 'pl-6',
  8: 'pl-8',
  10: 'pl-10',
  12: 'pl-12',
  16: 'pl-16',
  20: 'pl-20',
  24: 'pl-24',
}
const W_MAP: Record<SpacingScale, string> = {
  0: 'w-0',
  1: 'w-1',
  2: 'w-2',
  3: 'w-3',
  4: 'w-4',
  5: 'w-5',
  6: 'w-6',
  8: 'w-8',
  10: 'w-10',
  12: 'w-12',
  16: 'w-16',
  20: 'w-20',
  24: 'w-24',
}
const H_MAP: Record<SpacingScale, string> = {
  0: 'h-0',
  1: 'h-1',
  2: 'h-2',
  3: 'h-3',
  4: 'h-4',
  5: 'h-5',
  6: 'h-6',
  8: 'h-8',
  10: 'h-10',
  12: 'h-12',
  16: 'h-16',
  20: 'h-20',
  24: 'h-24',
}
const MIN_W_MAP: Record<SpacingScale, string> = {
  0: 'min-w-0',
  1: 'min-w-1',
  2: 'min-w-2',
  3: 'min-w-3',
  4: 'min-w-4',
  5: 'min-w-5',
  6: 'min-w-6',
  8: 'min-w-8',
  10: 'min-w-10',
  12: 'min-w-12',
  16: 'min-w-16',
  20: 'min-w-20',
  24: 'min-w-24',
}
const ALIGN_SELF_MAP: Record<'start' | 'center' | 'end' | 'stretch' | 'baseline', string> = {
  start: 'self-start',
  center: 'self-center',
  end: 'self-end',
  stretch: 'self-stretch',
  baseline: 'self-baseline',
}
export const GAP_MAP: Record<SpacingScale, string> = {
  0: 'gap-0',
  1: 'gap-1',
  2: 'gap-2',
  3: 'gap-3',
  4: 'gap-4',
  5: 'gap-5',
  6: 'gap-6',
  8: 'gap-8',
  10: 'gap-10',
  12: 'gap-12',
  16: 'gap-16',
  20: 'gap-20',
  24: 'gap-24',
}
const GAP_X_MAP: Record<SpacingScale, string> = {
  0: 'gap-x-0',
  1: 'gap-x-1',
  2: 'gap-x-2',
  3: 'gap-x-3',
  4: 'gap-x-4',
  5: 'gap-x-5',
  6: 'gap-x-6',
  8: 'gap-x-8',
  10: 'gap-x-10',
  12: 'gap-x-12',
  16: 'gap-x-16',
  20: 'gap-x-20',
  24: 'gap-x-24',
}
const GAP_Y_MAP: Record<SpacingScale, string> = {
  0: 'gap-y-0',
  1: 'gap-y-1',
  2: 'gap-y-2',
  3: 'gap-y-3',
  4: 'gap-y-4',
  5: 'gap-y-5',
  6: 'gap-y-6',
  8: 'gap-y-8',
  10: 'gap-y-10',
  12: 'gap-y-12',
  16: 'gap-y-16',
  20: 'gap-y-20',
  24: 'gap-y-24',
}

export interface BoxSpacingProps {
  p?: SpacingScale
  px?: SpacingScale
  py?: SpacingScale
  pt?: SpacingScale
  pr?: SpacingScale
  pb?: SpacingScale
  pl?: SpacingScale
  /** Sets both width and height to the same value. Overridden by explicit `width` or `height` props. */
  size?: SpacingScale | string
  width?: SpacingScale | string
  height?: SpacingScale | string
}

export interface GapProps {
  gap?: SpacingScale
  gapX?: SpacingScale
  gapY?: SpacingScale
}

export interface FlexItemProps {
  /**
   * Fill available space along the flex parent's main axis (`flex: 1 1 0`).
   * Structural sizing — use instead of `style={{flex: 1}}`.
   */
  flex?: boolean
  /** Whether this item grows to fill free space (`flex-grow: 1` / `0`). */
  grow?: boolean
  /** Whether this item may shrink below its content size (`flex-shrink: 1` / `0`). */
  shrink?: boolean
  /**
   * Minimum width, using the spacing scale (0–24). `0` is the canonical fix for
   * the flex text-truncation blowout (a flex child won't shrink below its
   * content width without `min-width: 0`).
   */
  minWidth?: SpacingScale
  /** Override the parent's cross-axis alignment for this item. Maps to `align-self`. */
  alignSelf?: 'start' | 'center' | 'end' | 'stretch' | 'baseline'
}

export function buildBoxClasses(props: BoxSpacingProps): string {
  const classes: string[] = []
  if (props.p !== undefined) classes.push(P_MAP[props.p])
  if (props.px !== undefined) classes.push(PX_MAP[props.px])
  if (props.py !== undefined) classes.push(PY_MAP[props.py])
  if (props.pt !== undefined) classes.push(PT_MAP[props.pt])
  if (props.pr !== undefined) classes.push(PR_MAP[props.pr])
  if (props.pb !== undefined) classes.push(PB_MAP[props.pb])
  if (props.pl !== undefined) classes.push(PL_MAP[props.pl])
  // size first so explicit width/height win via tailwind-merge
  if (typeof props.size === 'number') {
    classes.push(W_MAP[props.size])
    classes.push(H_MAP[props.size])
  }
  if (typeof props.width === 'number') classes.push(W_MAP[props.width])
  if (typeof props.height === 'number') classes.push(H_MAP[props.height])
  return classes.filter(Boolean).join(' ')
}

export function buildGapClasses(props: GapProps): string {
  const classes: string[] = []
  if (props.gap !== undefined) classes.push(GAP_MAP[props.gap])
  if (props.gapX !== undefined) classes.push(GAP_X_MAP[props.gapX])
  if (props.gapY !== undefined) classes.push(GAP_Y_MAP[props.gapY])
  return classes.filter(Boolean).join(' ')
}

export function buildFlexItemClasses(props: FlexItemProps): string {
  const classes: string[] = []
  if (props.flex) classes.push('flex-1')
  if (props.grow !== undefined) classes.push(props.grow ? 'grow' : 'grow-0')
  if (props.shrink !== undefined) classes.push(props.shrink ? 'shrink' : 'shrink-0')
  if (props.minWidth !== undefined) classes.push(MIN_W_MAP[props.minWidth])
  if (props.alignSelf !== undefined) classes.push(ALIGN_SELF_MAP[props.alignSelf])
  return classes.filter(Boolean).join(' ')
}

export const FlexVariantsFactory = cva('flex', {
  variants: {
    direction: {
      row: 'flex-row',
      column: 'flex-col',
      'row-reverse': 'flex-row-reverse',
      'column-reverse': 'flex-col-reverse',
    },
    align: {
      start: 'items-start',
      center: 'items-center',
      end: 'items-end',
      stretch: 'items-stretch',
      baseline: 'items-baseline',
    },
    justify: {
      start: 'justify-start',
      center: 'justify-center',
      end: 'justify-end',
      between: 'justify-between',
    },
    wrap: {
      nowrap: 'flex-nowrap',
      wrap: 'flex-wrap',
      'wrap-reverse': 'flex-wrap-reverse',
    },
  },
})

export const GridVariantsFactory = cva('grid', {
  variants: {
    align: {
      start: 'items-start',
      center: 'items-center',
      end: 'items-end',
      stretch: 'items-stretch',
      baseline: 'items-baseline',
    },
    justify: {
      start: 'justify-start',
      center: 'justify-center',
      end: 'justify-end',
      between: 'justify-between',
    },
  },
})
